import React from 'react'
import styles from './Characters.module.css'
import {
  CharactersPhoto,
  Opening90,
  DesignStyle,
  ManualSteering,
  HomeKit,
  LongLifetime,
  SafeAnimals,
  PilotSteering,
  AlwaysClean,
  SafeKids,
  Auto,
} from '../../../Assets/Images/WindowsPage/Characters/Index'

const cards = [
  { icon: Opening90, title: "Opening 90°" },
  { icon: DesignStyle, title: "Design & Style" },
  { icon: ManualSteering, title: "Manually steering" },
  { icon: HomeKit, title: "Apple HomeKit/Android" },
  { icon: LongLifetime, title: "Long lifetime" },
  { icon: SafeAnimals, title: "Safe for animals" },
  { icon: PilotSteering, title: "Pilot steering" },
  { icon: AlwaysClean, title: "Always clean" },
  { icon: SafeKids, title: "Safe for kids" },
  { icon: Auto, title: "Auto" },
];

const Characters = () => {
  return (
    <section className={styles.wrap} id="characters">
      <div className={`customContainer ${styles.container}`}>

        {/* TITLE */}
        <div className={styles.titles}>
          <hr className={styles.titles_line} />
          <h2 className={styles.titles_title}>Characters of Windows</h2>
          <hr className={styles.titles_line} />
        </div>

        <div className={styles.content}>

          {/* LEFT — TEXT & CARDS */}
          <div className={styles.column}>
            <p className={styles.desc}>
              Unique and exclusive solutions, such as, for example, Perfect Comfort Life - blinds integrated into the
              glass unit, raise the comfort of using PerfectWin windows to the highest level.
            </p>

            <div className={styles.grid}>
              {cards.map((item) => (
                <div className={styles.card} key={item.title}>
                  <img src={item.icon} alt="" className={styles.card_icon} />
                  <h3 className={styles.card_title}>{item.title}</h3>
                  <span className={styles.card_line}></span>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT — PHOTO */}
          <div className={styles.photo}>
            <img src={CharactersPhoto} alt="Perfect Comfort Life window" className={styles.photo_img} />
            <span className={styles.photo_label}>Comfort Life</span>
          </div>

        </div>

      </div>
    </section>
  )
}

export default Characters
